module.exports = __webpack_public_path__ + "static/media/sunny.ca7e1760.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sunny.gif
// module id = 1207
// module chunks = 110